import { render, staticRenderFns } from "./ListaRemocoes.vue?vue&type=template&id=07fac413&"
import script from "./ListaRemocoes.vue?vue&type=script&lang=js&"
export * from "./ListaRemocoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports